import type { MouseEvent } from 'react';
import { useMemo } from 'react';

import type { Item } from './model';

import { useTranslateFn } from '@shared/Translate';
import GoogleTagManagerHelper from '@tracking/gtm-helper';

export const useItemText = (item: Item): string => {
  const t = useTranslateFn();

  return useMemo(() => {
    if (!item) return '';
    return item.text || t(item.tag);
  }, [item, t]);
};

export const handleMenuItemClick = (level: string, trackText: string) => (event: MouseEvent<HTMLElement>) => {
  if (event.button > 1) return;
  event.stopPropagation();

  sendHeaderTracking(trackText, level);
};

export const sendHeaderTracking = (trackText: string, level: string, prefix = 'Access') => {
  GoogleTagManagerHelper.ga4Event('navigation_main', {
    navigation_type: `Menu - ${level} - ${[prefix, trackText].join(' ')}`,
  });
};

export const K = {
  ddDistance: 21,
  ddDistanceMobile: 11,
};

export const checkMyUefaCustomProperty = (customProperties: Record<string, any>): boolean =>
  customProperties?.class === 'myuefa';
